import styled from 'styled-components';
import {Button, Space} from 'antd';
import Card from '../../../Card';

const StyledInvoiceDetailsCard = styled(Card)`
  margin-top: 16px;

  .ant-card-body {
    min-height: 64px;
    position: relative;
    text-align: center;
    transition: .2s ease;

    button:not(.ant-btn-icon-only) {
      color: ${props => props.theme.colors.primary_6};

      &:hover {
        color: ${props => props.theme.colors.primary_6};
      }
    }
  }
`;


const StyledInvoiceDetailsIconButton = styled(Button)`
  align-items: center;
  display: flex;
  justify-content: center;

  svg {
    height: 16px;
    width: 16px;

    path {
      fill: ${props => props.theme.colors.neutral_10};
      transition: .2s ease;
    }
  }
`;

const StyledInvoiceDetailsFileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 130px;
  white-space: nowrap;
`;


const StyledInvoiceDetailsFormSpace = styled(Space)`
  justify-content: space-between;
  width: 100%;

  form {
    min-width: 100px;
  }

  svg {
    path {
      fill: ${props => props.theme.colors.neutral_6};
    }
  }

  .ant-space-item {
    display: flex;
  }

  .placeholder {
    height: 42px;
    width: 42px;
  }
`;

export {
  StyledInvoiceDetailsCard,
  StyledInvoiceDetailsIconButton,
  StyledInvoiceDetailsFileName,
  StyledInvoiceDetailsFormSpace,
};
